/**
 * Classe responsável pela interface de transferir Stops entre rotas.
 *
 * @author: Adalto Junior
 * DATE: 09/04/2013
 *
 */


Greenmile.Route = Greenmile.Route || {};
Greenmile.Route.TransferStops = Greenmile.Route.TransferStops || {};
Greenmile.Route.TransferStops.Popup = function (
  {
    parentSelector = '#RouteSummary'
  } = {}
) {

    Greenmile.Route.TransferStops.RouteName = {};

    this.modalForm = null;
    this.routeId = null;
    this.blockOverlaySelector = '.mainContainer';

    this.createHeaderForm = function () {

        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        const date = new Monet.Date.GeneralFunctions();

        if (modalContainer !== null) {

            const layout = {
                "items": [
                    {
                        "tag": "form",
                        "items": [
                            {
                                "items": [
                                    {
                                        "attributes": {
                                            "class": "monetInlineAlerContainer"
                                        }
                                    },
                                    {
                                        "items": [
                                            {
                                                "attributes": {
                                                    "class": "popup-modal-header"
                                                },
                                                "items": [
                                                    {
                                                        "tag": "h3",
                                                        "html": Monet.I18n.getResourcesByKey('greenmile.routesummary.transferstops.modal.title'),
                                                    },
                                                    {
                                                        "tag": "div",
                                                        "items": [
                                                            {
                                                                "tag": "a",
                                                                "attributes": {
                                                                    "href": "https://greenmile.help.descartesservices.com",
                                                                    "class": "MonetUIHelpLink",
                                                                    "title": "Help"
                                                                },
                                                            }
                                                        ],
                                                        "attributes": {
                                                            "class": "MonetUIHelp"
                                                        },


                                                    }
                                                ]
                                            },
                                        ],
                                    }
                                ]
                            }
                        ],
                    }
                ]
            };

            modalContainer.appendChild((new Monet.UI.LayoutGenerator(layout)).render());

            date.setDateTimePicker(`${parentSelector} .dateTimePicker`);

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }


    };

    this.setFromRouteId = function (routeId) {
        this.routeId = routeId;
    };

    this.showTransferStops = function () {
        this.modalForm.showModalForm();
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.createHeaderForm();
            scope.prepareToCreateForm();
            scope.addContentToModalForm();
            scope.addEventListeners();
        };
    }(this);

    this.prepareToCreateForm = function () {

        var util = new Greenmile.Route.ModalUtils();
        util.ajustModalOverlay(this.blockOverlaySelector);

    };

    this.addContentToModalForm = function () {

        var error        = null,
            modalContent = document.querySelector(`${parentSelector} .popupFormContainer`);

        if (modalContent) {

            var content = new Greenmile.Route.TransferStops.PopupContent();

            modalContent.appendChild(content.render());
            this.getStopsAndAddToList();

        } else {

            error = new Monet.Exception.ReturnError(this,
                "No modal to add content.");
            error.console();

        }
    };

    this.addEventListeners = function () {

        $(`${parentSelector} .closeModalWindow`).off();
        $(`${parentSelector} .closeModalWindow`).on("click", function () {
            Greenmile.Route.TransferStops.RouteName = {};
        });
    };

    this.getStopsAndAddToList = () => {
      const filter = {
        id: this.routeId
      };
      const selector = '#stopsRouteSelected';
      const request = new Greenmile.Route.TransferStops.Requests();
      Monet.Session.TransferStops = Monet.Session.TransferStops || {};
      Monet.Session.TransferStops.stopsRouteSelected = { filter };
      request.getStopsAndAddToList(filter, selector);
    };

    var init = function (scope) {

        return function (scope) {

            const selector = parentSelector;
            const options = {
              width: 800,
              height: 575,
              className: 'transferStopsPopup'
            };
            const callbacks = {
              onAfterShowModalForm: scope.createAllStructure
            };

            scope.selector = selector;
            scope.scopeBlock = scope.blockOverlaySelector;
            scope.selectormodalContent = selector + " .popupFormContainer";

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scope.blockOverlaySelector);

        }(scope);

    };

    init(this);
};

Greenmile.Route.ControlSortable = {
    receiveWasExecuted: false,
    receiveBestInsertionWasExecuted: false,
    sender: ""
};

